import React from 'react';

import { ValuatorSearchGridResponse } from '@/main/models/response';
import { KOGTableRow } from '@/main/components/shared/boxGrid/styles';
import { TableCell } from '@mui/material';
import StatusComponent from '@/main/components/shared/status/statusComponent';

import { RoutesConstants } from '@/main/routes/routesConstants';
import { useNavigate } from 'react-router-dom';
import { getTranslateByKey } from '@/main/services/utils';
import { toast } from 'react-toastify';

interface IRowSearchValuatorProps {
  valuator: ValuatorSearchGridResponse;
  index: number;
}

function RowValuatorScreen({ valuator, index }: IRowSearchValuatorProps) {
  const navigate = useNavigate();

  function handleRowBoxGrid(register: ValuatorSearchGridResponse) {
    if(register.hasOtherCompanyRelation){
         toast.error(getTranslateByKey('information.valuatorAssociatedWithAnotherInsurance', true));
         return;
        }
    navigate(
      `${RoutesConstants.registrationRegisterValuator}?valuatorGuid=${register.guid}`
    );
  }

  function renderAddress(valuator: ValuatorSearchGridResponse) {
    if (valuator.addresses && valuator.addresses.length > 0) {
      const state = valuator.addresses[0]?.municipality?.city?.state?.name;
      const city = valuator.addresses[0]?.municipality?.city?.name;
      if (state && city) {
        return `${state} / ${city}`;
      }
    }
    return <></>;
  }

  return (
    <KOGTableRow
      key={valuator.guid}
      onClick={() => handleRowBoxGrid(valuator)}>
      <TableCell width="25%">{valuator.registrationNumber}</TableCell>
      <TableCell>
        <div
          style={{
            maxWidth: 250,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
          {valuator.name}
        </div>
      </TableCell>
      <TableCell width="35%">{renderAddress(valuator)}</TableCell>
      <TableCell width="10%">
        <StatusComponent status={valuator?.statusRegister} />
      </TableCell>
    </KOGTableRow>
  );
}

export default RowValuatorScreen;
